<template>
  <v-card flat >
    <v-card-title primary-title class="justify-center">
      <img :src="`${this.customBasePath}/logo.png`" style="max-width:100%;max-height:60px" alt="Logo"/>
    </v-card-title>
    <v-card-subtitle class="text-center pb-0">
      <div class="pt-6 headline font-weight-light">{{emailDescription}} </div>
    </v-card-subtitle>
    <v-card-text>
      <v-container>
        <v-form ref="form" v-model="valid">
          <v-col cols="12" >
            <v-text-field
                outlined
                v-model="userName"
                :disabled="app_loading"
                hide-details
                required
                :rules="nameRules"
                :label="emailInputPlaceholder"
                @keydown.enter="doGuestLogin"
                placeholder="">
            </v-text-field> 
          </v-col>

          <!-- Navigation Buttons -->
          <v-row align="center" justify="center" class="ma-0 mt-3">
            <v-col v-if="!onlyGuestAccessEnabled" cols="12" md="6" align="center">
              <v-btn large depressed block color="grey lighten-1" dark rounded  @click="close(false)" >{{$t('back')}}</v-btn>
            </v-col>
            <v-col cols="12" :md="6" align="center">
              <v-btn large depressed block :color="theme.btnColorPrimary"  rounded  dark @click="doGuestLogin"  :loading="app_loading" >{{$t('loginBtn')}}</v-btn>
              <div v-if="login_error" class="red--text" v-html="$t('errorCodeInvalidCredentials')"></div>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import CONFIG from '@/constants/config.js';
import {layoutMixin} from '@/utils/layout-mixin'
import {settingsMixin} from '@/utils/settings-mixin'
import {validationMixin} from '@/utils/validation-mixin'
import sha1 from "js-sha1";

export default {
  mixins:[settingsMixin,validationMixin,layoutMixin],
  data: () => ({
    userName:'',
    valid: true,
    login_error: false,
    use_username:(process.env.VUE_APP_APP_CUSTOM_ID!="tbeiersdorf_app")
  }),
  computed:{
    registerData(){
      return {
        username:this.userName,
        email:this.getUuid + '@espoto.com',
        password:sha1(this.password+this.email),
        confirm_password:sha1(this.password+this.email),
        is_test_account:true,
      }
    },

    emailDescription(){
      return (this.use_username)?this.$t('demoQuestion'):this.$t('welcomeEmailPlaceholder');
    },
    emailInputPlaceholder(){
      return (this.use_username)?this.$t('loginUsername'):this.$t('loginEmail');
    },

    getUuid() {
      let chars = '0123456789abcdef'.split('');

      let uuid = [], rnd = Math.random, r;
      uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
      uuid[14] = '4'; // version 4

      for (let i = 0; i < 36; i++) {
        if (!uuid[i]) {
          r = 0 | rnd()*16;
          uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r & 0xf];
        }
      }
      return uuid.join('');
    },

    disableLogin() {
      return this.parseBoolean(CONFIG.DISABLE_LOGIN, false)
    },
    disableGuestAccess() {
      return this.parseBoolean(CONFIG.DISABLE_GUEST_ACCESS, false)
    },
    disableQRAccess() {
      return this.parseBoolean(CONFIG.DISABLE_QR_ACCESS, false)
    },
    onlyGuestAccessEnabled() {
      return this.disableLogin && this.disableQRAccess && !this.disableGuestAccess
    },
    
  },
  methods:{

    close(withNotification=false){
      this.$emit('close', withNotification);
    },

    doGuestLogin() {
      if(!this.valid){
        this.validate();
        return;
      }

      this.login_error=false;
      this.registerAnonymous(this.registerData).then(()=> {
        this.$emit('next');
      }).catch(() => {
        console.log('Login error');
        this.login_error=true;
      });
    },

    validate () {
      this.$refs.form.validate()
    },

  }
}
</script>
